export function createNotificationApi({ apiUrl, getToken }) {
    const headers = (json = true) => {
        const h = { Authorization: `Bearer ${getToken()}` };
        if (json) h["Content-Type"] = "application/json";
        return h;
    };

    const base = `${apiUrl}/notifications`;

    return {
        async list(params = {}) {
            const q = new URLSearchParams();
            Object.entries(params).forEach(([k, v]) => {
                if (v !== undefined && v !== "" && v !== null) q.set(k, String(v));
            });
            const res = await fetch(`${base}?${q.toString()}`, { headers: headers(false) });
            const data = await res.json();
            if (!res.ok) throw new Error(data.message || "Failed to load notifications");
            return data;
        },
        async unreadCount() {
            const res = await fetch(`${base}/unread-count`, { headers: headers(false) });
            const data = await res.json();
            if (!res.ok) throw new Error(data.message || "Failed to load unread count");
            return Number(data.count) || 0;
        },
        async markRead(ids, all = false) {
            const res = await fetch(`${base}/read`, {
                method: "POST",
                headers: headers(),
                body: JSON.stringify(all ? { all: true } : { ids }),
            });
            if (!res.ok) throw new Error("Failed to mark read");
        },
        async archive(ids) {
            const res = await fetch(`${base}/archive`, {
                method: "POST",
                headers: headers(),
                body: JSON.stringify({ ids }),
            });
            if (!res.ok) throw new Error("Failed to archive");
        },
        async getPreferences() {
            const res = await fetch(`${base}/preferences`, { headers: headers(false) });
            const data = await res.json();
            if (!res.ok) throw new Error("Failed to load preferences");
            return data.data;
        },
        async savePreferences(patch) {
            const res = await fetch(`${base}/preferences`, {
                method: "PUT",
                headers: headers(),
                body: JSON.stringify(patch),
            });
            const data = await res.json();
            if (!res.ok) throw new Error("Failed to save preferences");
            return data.data;
        },
        async logOpened(taskId) {
            await fetch(`${base}/opened/${taskId}`, { method: "POST", headers: headers() }).catch(() => null);
        },
        async listWatchers(taskId) {
            const res = await fetch(`${base}/watchers/${taskId}`, { headers: headers(false) });
            const data = await res.json();
            if (!res.ok) throw new Error(data.message || "Failed to load watchers");
            return data;
        },
        async watch(taskId, staffId) {
            const res = await fetch(`${base}/watchers/${taskId}`, {
                method: "POST",
                headers: headers(),
                body: JSON.stringify(staffId ? { staff_id: staffId } : {}),
            });
            if (!res.ok) throw new Error("Failed to watch task");
            return res.json();
        },
        async unwatch(taskId, staffId) {
            const q = staffId ? `?staff_id=${encodeURIComponent(staffId)}` : "";
            const res = await fetch(`${base}/watchers/${taskId}${q}`, {
                method: "DELETE",
                headers: headers(),
            });
            if (!res.ok) throw new Error("Failed to unwatch");
        },
        async getTemplates() {
            const res = await fetch(`${base}/templates`, { headers: headers(false) });
            const data = await res.json();
            if (!res.ok) throw new Error(data.message || "Failed to load templates");
            return data.data || [];
        },
        async saveTemplate(eventType, patch) {
            const res = await fetch(`${base}/templates/${eventType}`, {
                method: "PUT",
                headers: headers(),
                body: JSON.stringify(patch),
            });
            const data = await res.json();
            if (!res.ok) throw new Error(data.message || "Failed to save template");
            return data.data;
        },
        async getTenantSettings() {
            const res = await fetch(`${base}/settings`, { headers: headers(false) });
            const data = await res.json();
            if (!res.ok) throw new Error(data.message || "Failed to load settings");
            return data.data;
        },
        async saveTenantSettings(patch) {
            const res = await fetch(`${base}/settings`, {
                method: "PUT",
                headers: headers(),
                body: JSON.stringify(patch),
            });
            const data = await res.json();
            if (!res.ok) throw new Error(data.message || "Failed to save settings");
            return data.data;
        },
    };
}
